import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotAuthorized = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "0 0 184 184",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#000",
		strokeWidth: 4,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m37.996 166.652c1.268.508 2.458.8 3.53.8 6.288 0 10.778.45 22.007-10.779 11.228-11.228 41.545-57.713 24.253-75.004-17.291-17.292-63.776 13.025-75.004 24.253-11.229 11.228-10.78 15.72-10.78 22.007 0 1.071.293 2.262.801 3.53 2.475 6.17 10.19 14.198 15.593 19.6 5.402 5.403 13.43 13.118 19.6 15.593z" }),
			/* @__PURE__ */ _jsx("path", { d: "m14.91 131.244.879-.88a3.106 3.106 0 0 1 4.392 0l19.91 19.91a3.104 3.104 0 0 1 0 4.391l-.88.88a3.104 3.104 0 0 1 -4.391 0l-19.91-19.91a3.106 3.106 0 0 1 0-4.391z" }),
			/* @__PURE__ */ _jsx("path", { d: "m38.805 166.455a106.575 106.575 0 0 0 5.05-4.766c11.105-11.104 43.492-54.67 31.536-66.626-11.955-11.955-55.521 20.432-66.626 31.537a106.574 106.574 0 0 0 -4.765 5.05c2.447 6.101 10.077 14.041 15.42 19.384 5.344 5.344 13.284 12.974 19.385 15.42zm64.693-114.443v7.747h-7.621l-17.877 16.696c3.704.654 7.408 2.366 10 5 2.592 2.635 4.357 6.235 5 10l17.167-17.17 2.858-7.748 6.67-1.936.305-4.93-12.018-12.216zm43.368 7.443 4.821-3.333 5.51 3.333h12.396l10.532-6.65a3.931 3.931 0 0 0 0-6.7l-10.532-6.65h-8.953l-11.708 5.333-5.509-5.333h-11.423v16.82l5.914 3.18z" }),
			/* @__PURE__ */ _jsx("path", { d: "m100.466 27.508 11.995 2.984m8.783-14.981-3.413 11.88" }),
			/* @__PURE__ */ _jsx("path", { d: "m134.64 73.902 11.995 2.984m-17.567-.234-3.413 11.88" })
		]
	})
});
export default SvgNotAuthorized;
